/**
 * BETA — CHIFA lookup + barcode + CNAS import.
 *
 * /chifa/lookup is driven by the shared nomenclature catalogue in
 * ./nomenclature.js so the autofill flow can be tested without a backend.
 * If the num_enregistrement matches a catalogue row, we return a rich payload
 * including taux_remboursement and a French libelle. As a fallback we also
 * search the in-memory produits store (legacy ChifaImportModal path), which
 * returns the existing produit row so ProduitList's preview keeps working.
 */
import { NOMENCLATURE_CATALOGUE, findByNumEnregistrement } from "./nomenclature.js";

export function register(route) {
  route("GET", "/chifa/lookup", (ctx) => {
    const num = ctx.params.num || ctx.params.num_enr;
    if (!num) {
      return {
        found: false,
        message: "Paramètre num requis",
      };
    }

    // 1) Primary: hit the hard-coded nomenclature catalogue.
    const nom = findByNumEnregistrement(num);
    if (nom) {
      return {
        found: true,
        num_enregistrement: nom.num_enregistrement,
        nom_commercial: nom.nom_marque,
        nom_marque: nom.nom_marque,
        dci: nom.dci,
        forme: nom.forme,
        dosage: nom.dosage,
        laboratoire: nom.laboratoire,
        conditionnement: nom.conditionnement,
        classe_therapeutique: nom.classe_therapeutique,
        remboursable: nom.remboursable,
        taux_remboursement: nom.taux_remboursement,
        libelle: nom.libelle,
      };
    }

    // 2) Fallback: search the in-memory produits store so the legacy
    //    ChifaImportModal preview keeps working for products already in
    //    the demo catalogue but not in the nomenclature list above.
    const fromStore = ctx.store.data.produits.find(
      (p) => p.num_enr_cnas === num,
    );
    if (fromStore) {
      return {
        found: true,
        num_enregistrement: fromStore.num_enr_cnas,
        nom_commercial: fromStore.nom_commercial,
        nom_marque: fromStore.nom_commercial,
        dci: fromStore.dci || "",
        forme: fromStore.forme_pharma || "",
        dosage: fromStore.dosage || "",
        laboratoire: fromStore.laboratoire_id || "",
        remboursable: !!fromStore.is_remboursable,
        taux_remboursement: fromStore.is_remboursable ? 80 : 0,
        libelle: fromStore.nom_commercial,
      };
    }

    return {
      found: false,
      message: "Numéro non trouvé dans la base CNAS (démo)",
    };
  });

  route("POST", "/chifa/import", (ctx) => {
    const records = ctx.body?.records || [];
    return {
      success: true,
      inserted: records.length,
      skipped: 0,
      message: "Import CNAS simulé (démo)",
    };
  });

  // Diagnostic / health route — kept off the hot path so a future page that
  // wants to display "X products in nomenclature" can call it without
  // re-implementing the catalogue size.
  route("GET", "/chifa/catalogue/count", () => ({
    count: NOMENCLATURE_CATALOGUE.length,
  }));
}
